import React from 'react';
import CommandCenterNew from '../components/CommandCenterNew';

/**
 * Dashboard - Centre de Commande Navy/Tactical
 * 
 * L'ancienne version classique a été supprimée.
 * Seule la nouvelle version Navy est conservée.
 */
const Dashboard = () => {
  return (
    <div className="min-h-screen" data-testid="dashboard">
      <CommandCenterNew />
    </div>
  );
};

export default Dashboard;
